export default {
  title: '{{plan}} is active',
  plan: 'Plan: {{plan}}',
  free_until: 'Free until {{date}}',
  continue: 'Continue',
};
